import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import GeneralForm from "../../components/general-form/general-form";
import CustomButton from "../../components/custom-button/custom-button";
import { login, verifyAdminOtp } from "../../store/features/auth/authSlice";

export default function Login() {
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const [challengeId, setChallengeId] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const fields = [
    { name: "email", type: "email", label: "Email", isRequired: true },
    { name: "password", type: "password", label: "Mật khẩu", isRequired: true },
  ];

  const onSubmit = async (data) => {
    if (loading) return;
    setLoading(true);
    try {
      const response = await dispatch(login(data)).unwrap();
      if (response.data?.requiresTwoFactor && response.data?.challengeId) {
        setChallengeId(response.data.challengeId);
        setCode("");
      }
    } catch (_) {
      // Errors are displayed by the existing toast middleware.
    } finally {
      setLoading(false);
    }
  };

  const handleVerify = async (event) => {
    event.preventDefault();
    if (!/^[0-9]{6}$/.test(code) || loading) return;
    setLoading(true);
    try {
      const response = await dispatch(verifyAdminOtp({ challengeId, code })).unwrap();
      if (response.success) window.location.replace("/");
    } catch (_) {
      // Remain on the OTP entry screen so the user can retry.
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-100 flex items-center justify-center min-h-screen px-4">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <h1 className="text-2xl font-bold text-center text-gray-800 mb-6">
          Ji miso
          <br />
          <span className="text-lg font-normal">
            {challengeId ? "Xác thực email" : "Đăng nhập"}
          </span>
        </h1>

        {challengeId ? (
          <form onSubmit={handleVerify}>
            <p className="text-sm text-gray-600 mb-4">
              Nhập mã xác thực 6 số vừa gửi tới email quản trị. Mã có hiệu lực trong 5 phút.
            </p>
            <label htmlFor="admin-otp" className="block text-gray-600 mb-1">
              Mã xác thực
            </label>
            <input
              id="admin-otp"
              name="code"
              type="text"
              value={code}
              onChange={(event) => setCode(event.target.value.replace(/\D/g, "").slice(0, 6))}
              inputMode="numeric"
              pattern="[0-9]{6}"
              autoComplete="one-time-code"
              maxLength={6}
              autoFocus
              required
              className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <div className="flex justify-between items-center gap-2 mt-4">
              <button
                type="button"
                disabled={loading}
                className="text-sm text-blue-600 underline"
                onClick={() => { setChallengeId(""); setCode(""); }}
              >
                Quay lại đăng nhập
              </button>
              <button
                type="submit"
                disabled={loading || code.length !== 6}
                className="bg-[#34699A] text-white px-4 py-2 rounded-md hover:bg-[#9EC6F3] disabled:opacity-50"
              >
                {loading ? "Đang xác thực..." : "Xác thực"}
              </button>
            </div>
          </form>
        ) : (
          <>
            <GeneralForm
              ref={formRef}
              props={{ fields, onSubmit, hiddenSubmitBtn: true }}
            />
            <div className="mt-3 text-right">
              <Link to="/forgot-password" className="text-sm text-blue-600 underline">
                Quên mật khẩu?
              </Link>
            </div>
            <div className="w-full flex flex-row justify-end gap-2 mt-4">
              <div className="w-32">
                <CustomButton
                  props={{ title: loading ? "Đang gửi..." : "Đăng nhập", onClick: () => formRef.current?.submitForm() }}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
